import FeathersHelper from "../../helpers/feathers";

export const find = (payload) =>
  FeathersHelper.find('alerts', payload);
export const create = (payload) =>
  FeathersHelper.create('alerts', payload);
export const patch = (id, payload, params = {}) => FeathersHelper.patch('alerts', id, payload, params);
export const remove = (id, params = {}) => FeathersHelper.remove('alerts', id, params);

